import React, { createContext, useContext, useState, useCallback } from "react";
import { dict } from "@/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("kv_lang") || "hi");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "hi" ? "en" : "hi";
      localStorage.setItem("kv_lang", next);
      return next;
    });
  }, []);

  const setLanguage = useCallback((l) => {
    localStorage.setItem("kv_lang", l);
    setLang(l);
  }, []);

  const t = useCallback(
    (key) => {
      const entry = dict[key];
      if (!entry) return key;
      return entry[lang] ?? entry.en ?? key;
    },
    [lang]
  );

  // pick a localized value from an object like {en, hi} or {field_en, field_hi}
  const pick = useCallback(
    (obj, base) => {
      if (!obj) return "";
      if (base) return obj[`${base}_${lang}`] ?? obj[`${base}_en`] ?? "";
      return obj[lang] ?? obj.en ?? "";
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, toggle, setLanguage, t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
